<!--
- 热门领域轮次分布
- 创建人: lzp
- 创建时间: 2019-10-10
-->
<template>
<div class="financing_data">
  <!-- 热点领域 融资事件 -->
  <div class="chart_bg">
    <div class="title">
      <span class="chart_name" v-if="params.data_type == 1">
        热点领域（数量）
        <Poptip class="poptip_round1" v-model="pop_tip" placement="bottom-start" word-wrap v-if="!spinShow">
          <div class="i-container"><i class="iconfont">&#xe668;</i></div>
          <div slot="content">
              <p><span>提示</span><i class="iconfont" @click="pop_tip=false">&#xe6c2;</i></p>
              <p>若公司业务涉及多个细分领域，其获得融资时，则该页面多个细分领域会同时计数（事件数、融资额）</p>
          </div>
        </Poptip>
      </span>
      <span class="chart_name" v-else>热点领域（亿{{params.unit_type | deal('unit')}}）
        <Poptip class="poptip_round2" v-model="pop_tip" placement="bottom-start" word-wrap v-if="!spinShow">
          <div class="i-container"><i class="iconfont">&#xe668;</i></div>
          <div slot="content">
              <p><span>提示</span><i class="iconfont" @click="pop_tip=false">&#xe6c2;</i></p>
              <p>若公司业务涉及多个细分领域，其获得融资时，则该页面多个细分领域会同时计数（事件数、融资额）</p>
          </div>
        </Poptip>
      </span>

      <div class="condition">
        <div class="change-unit">
          <Dropdown @on-click="handleChangeUnit">
            <a href="javascript:void(0)">{{params.unit_type | deal('unit')}}</a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in unit_list" :name="item.id" :key="item.id" :disabled="item.id == params.unit_type">{{ item.name }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="location">
          <AddressTab @selectAddress="addressChecked"></AddressTab>
        </div>
        <!-- <div class="upload">
          <a @click="haddleSave"><i class="iconfont">&#xe644;</i>下载</a>
        </div> -->
      </div>
    </div>

    <div class="hot_container">
      <div class="condition">
        <div class="time_sel2">
          <div class="ivu-radio-group">
            <label class="ivu-radio-wrapper ivu-radio-default" @click="changeKeyType(1)">
              <span :class="{'ivu-radio': true, 'ivu-radio-checked': params.data_type == 1}">
                <span class="ivu-radio-inner"></span>
              </span>
              <span>事件数</span>
            </label>
            <label class="ivu-radio-wrapper ivu-radio-default" @click="changeKeyType(2)">
              <span :class="{'ivu-radio': true, 'ivu-radio-checked': params.data_type == 2}">
                <span class="ivu-radio-inner"></span>
              </span>
              <span>融资额</span>
            </label>
          </div>
        </div>
      </div>
      <div class="hot_cnt" id="up_img">
        <ul class="hot_xf">
          <li @click="changely('' ,'全部')">
            <span :class="{'active': params.tag_arr.length == 0}">全部</span>
          </li>
          <li @click="changely(x.id, x.name)" v-for="(x,index) in tagmap" :key="x.id + '_' + index">
            <!-- <Tooltip placement="top" v-if="x.name.length > 6">
              <span :class="{'active': params.tag_arr.findIndex(a => x.id == a) > -1}">{{spliceString(x.name, 5)}}</span>
              <div slot="content">
                <p>{{x.name}}</p>
              </div>
            </Tooltip> -->
            <span :class="{'active': params.tag_arr.findIndex(a => x.id == a) > -1}">{{x.name}}</span>
          </li>
          <li>
            <span v-if="params.tag_arr.length == 0">总数</span>
          </li>
          <li></li>
          <li></li>
        </ul>
        <div class="hot_nr">
          <div class="hot-chart" v-if="params.tag_arr.length == 0 && can_render">
            <div class="hot-div-li">
              <div v-for="(xa, index) in x_axis" :key="xa">
                <ul>
                  <li></li>
                  <Tooltip placement="top" v-for="(x, idx) in tagmap" :key="xa + x.id + idx">
                    <li :style="{ 'background': showHex(hot_list[xa][x.name]) }">
                      {{hot_list[xa][x.name]}}
                    </li>
                    <div slot="content" v-if="params.data_type == 1">
                      <p class="p1">{{x.name}}</p>
                      <p class="p2">融资事件：<span>{{hot_list[xa][x.name]}}起</span></p>
                    </div>
                    <div slot="content" v-else>
                      <p class="p1">{{x.name}}</p>
                      <p class="p2">融资金额：<span>{{hot_list[xa][x.name]}}亿{{params.unit_type | deal('unit')}}</span></p>
                    </div>
                  </Tooltip>
                  <li>{{hot_list[xa]['sum']}}</li>
                </ul>
              </div>
            </div>
            <div class="hot-year hot-year1">
              <div class="hot-year-item" :class="{'hot-year-item-color':params.tag_arr.length > 0}" v-for="(x, idx) in x_axis" :key="x">{{x}}</div>
            </div>
          </div>
          <div class="hot_e" v-if="params.tag_arr.length == 1">
            <div class="chart current-hot" id="chart10"></div>
          </div>
          <div class="hot_e" v-if="params.tag_arr.length > 1">
            <div class="chart current-hot" id="arr_chart0"></div>
          </div>
          <Spin fix v-if="!can_render">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </div>
      <div class="time_slier">
        <Slider v-model="years" range :min="2011" :step="0.01" :tip-format="sliderTipFormat" :max="moment_year" @on-change="hadleTimeSlider" class="year_slider"></Slider>
        <div style="slier_axis" class="slier_axis">
          <span v-for="item,index in slier_axis" :key="item"  :style="'left:' + (100 / (slier_axis.length - 1)) * index + '%'">{{item}}</span>
        </div>
      </div>
    </div>
    <p class="data_src"><span>数据来源：动脉橙数据库</span><span>数据截止时间：{{today}}</span></p>
  </div>
  <div class="top-tip">全部<span>（{{total}}）</span>
    <Dropdown @on-click="haddleChangeSort">
      <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
      <DropdownMenu slot="list">
        <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  <div class="list_div">
    <Table :columns="columns" :data="list"></Table>
    <div class="page clear" v-if="total > 10">
      <Page :total="total" :page-size="10" :current="list_params.page" class="page_list" show-total show-elevator @on-change="handleChangePage" ref="pages" />
    </div>
  </div>
  <Contanct></Contanct>
  <DownloadCharts v-if="visible" :visible="visible" :imgbase="imgbase" :tabTitle="name" :pageTitle="page_title" :params="params" @closeecharts="closeEcharts"></DownloadCharts>
  <Spin fix v-if="spinShow">
    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    <div>Loading</div>
  </Spin>
  <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel">
    <p class="p1">亲，热点领域支持多个领域对比啦~</p>
    <p class="p2">普通用户仅2个，VIP会员数量更多</p>
  </VipPrompt>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import AddressTab from '../AddressTab'
import DownloadCharts from '../DownloadCharts2'
import VipPrompt from '@/components/VipPrompt.vue'
import {
  userInfo
} from 'js/userInfo'
import {
  financing_common
} from 'js/financing_mixins'
import {
  hex_mixin
} from 'js/hex_mixins'
import {
  option8
} from 'js/financing_chart'
import echarts from 'echarts'
import {
  hottagOfRoundMap, hotTagOfEventList
} from '../../../../service'
import moment from 'moment'
import html2canvas from 'html2canvas'

export default {
  mixins: [financing_common, hex_mixin, userInfo],
  props: ['tagmap'],
  components: {
    Contanct,
    AddressTab,
    DownloadCharts,
    VipPrompt
  },
  data() {
    const _this = this
    return {
      pop_tip: true,
      page_title: '当前热点领域',
      option: {
        color: ['#30D3EF', '#F89C95'],
        graphic: {
          type: 'image',
          style: {
            image: require('../../../../assets/pic/watermark-white.png'),
          }
        },
        legend: {
          data: [],
          top: '16px',
          left: '0',
          itemWidth: 10,
          itemHeight: 10,
          selectedMode: false,
          icon: "circle",
          textStyle: {
            color: '#BCBDC1',
            fontSize: 12
          },
          formatter: function(value) {
            return value.split('|')[0]
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#404040',
          padding: 10,
          formatter: function(params, ticket, callback) {
            let a_index = params.findIndex((a) => a.seriesName.split('|')[0] === '融资额'),
              e_index = params.findIndex((a) => a.seriesName.split('|')[0] === '事件数'),
              a_html = '',
              e_html = ''
            if (a_index > -1) {
              a_html = `<p class="p2">融资额：<span>` + params[a_index].value + `亿` + filter.deal(_this.params.unit_type, 'unit') + `</span></p>`
            }

            if (e_index > -1) {
              e_html = `<p class="p2">事件数：<span>` + params[e_index].value + `起</span></p>`
            }

            return `<div class="chart_tip">` + a_html + e_html + `</div>`
          }
        },
        grid: {
          left: '0',
          right: '0',
          top: '80px',
          bottom: '0',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: [],
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: 'rgba(255,255,255,0.30)'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#40444F',
              width: 1
            }
          },
          axisLabel: {
            textStyle: {
              color: '#BCBDC1'
            },
            interval: 0
          }
        }],
        yAxis: [{
          type: 'value',
          scale: true,
          axisLabel: {
            textStyle: {
              color: '#BCBDC1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#40444F',
              width: 1,
              type: 'dashed',
            }
          },
          min: 0,
          minInterval: 1
        }, {
          type: 'value',
          // name: '增长率',
          // nameTextStyle: {
          //     color: '#797B83'
          // },
          scale: true,
          axisLabel: {
            textStyle: {
              color: '#BCBDC1'
            }
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          minInterval: 1
        }],
        series: [{
          name: '',
          type: 'bar',
          yAxisIndex: 0,
          barWidth: 30,
          itemStyle: {
            normal: {
              color: function(params) {
                if (params.dataIndex === _this.curInt) {
                  return {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0,
                      color: '#2f91a6'
                    }, {
                      offset: 1,
                      color: '#2e76ad'
                    }]
                  }
                } else {
                  return {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0,
                      color: '#30D3EF'
                    }, {
                      offset: 1,
                      color: '#31A8FD'
                    }]
                  }
                }
              },
              barBorderRadius: [2, 2, 0, 0]
            }
          },
          label: {
            normal: {
              show: true,
              position: 'top',
              color: '#BCBDC1',
              formatter: function(params, ticket, callback) {
                return params.value
              }
            }
          },
          data: []
        }]
      }, // chart图使用配置5
      arr_option: option8,
      curInt: '',
      list: [], // 表格数据
      list_params: {
        user_key: this.$store.state.user_key,
        page: 1,
        sort_type: 0,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        round_ids: [],
        tag_arr: []
      },
      params: { // 请求参数
        user_key: this.$store.state.user_key,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        unit_type: 3,
        data_type: 1,
        tag_arr: []
      },
      x_axis: [], // 图表X轴
      y_axis: [], // 图表Y轴
      hot_list: {},
      can_render: false // 监听是否可以开始渲染
    }
  },
  computed: {
    name() {
      return '轮次分布-' + (this.params.data_type == 1 ? '融资事件' : '融资额')
    },
    map_round() {
      return this.$store.state.map_round
    }
  },
  methods: {
    async getMap() {
      this.curInt = ''
      this.params.page = 1
      // this.params.round_ids = []
      this.can_render = false
      let res = await hottagOfRoundMap(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (this.is_destroyed) {
          return false
        }
        this.x_axis = []
        // 列表数据
        let chart_data = res.res // chart_data图表元数据
        this.hot_list = {} // {轮次：{领域：[]}}
        if (this.params.tag_arr.length == 0) { // 全部
          let max_num = 0, min_num = 0
          this.x_axis = this.map_round //X轴
          // 遍历图表数据空结构
          this.x_axis.map((a) => {
            this.hot_list[a] = {}
            this.tagmap.map((b) => {
              this.hot_list[a][b.name] = 0
              this.hot_list[a]['sum'] = 0
            })
          })
          if (this.params.data_type == 2) {
            chart_data.map((a) => {
              let tag_name = filter.dealName(a.tag_id, this.tagmap)
              this.hot_list[a.round_name][tag_name] += filter.amountFilter(a.total)
              this.hot_list[a.round_name]['sum'] += filter.amountFilter(a.total)
              this.hot_list[a.round_name][tag_name] = Math.round(this.hot_list[a.round_name][tag_name]*100)/100
              this.hot_list[a.round_name]['sum'] = Math.round(this.hot_list[a.round_name]['sum']*100)/100
              max_num = Math.max(max_num, filter.amountFilter(a.total))
              min_num = Math.min(min_num, filter.amountFilter(a.total))
            })
          } else {
            chart_data.map((a) => {
              let tag_name = filter.dealName(a.tag_id, this.tagmap)
              this.hot_list[a.round_name][tag_name] += Number(a.total)
              this.hot_list[a.round_name]['sum'] += Number(a.total)
              max_num = Math.max(max_num, Number(a.total))
              min_num = Math.min(min_num, Number(a.total))
            })
          }
          this.min_max_num = [min_num, max_num]
          this.$set(this.$data, 'hot_list', this.hot_list)
        } else if (this.params.tag_arr.length == 1){ // 单个领域
          var chart = echarts.init(document.getElementById('chart10'), 'macarons')
          if (this.params.data_type == 2) {
            this.option.legend.data = ['融资额' + '|' + this.params.unit_type]
            this.option.series[0].name = '融资额' + '|' + this.params.unit_type
          } else {
            this.option.legend.data = ['事件数']
            this.option.series[0].name = '事件数'
          }
          let total_amount = [],
            growth_rate = [],
            event_count = []
          this.map_round.map((a) => {
            let index = chart_data.filter(b => a == b.round_name)
            if (this.params.data_type == 2) {
              if (index.length > 0) {
                let sum = 0
                for (let i of index) {
                  sum = sum + filter.amountFilter(i.total)
                }
                total_amount.push(sum.toFixed(2))
              } else {
                total_amount.push(0)
              }
            } else {
              if (index.length > 0) {
                let sum = 0
                for (let i of index) {
                  sum = sum + parseInt(i.total)
                }
                event_count.push(sum)
              } else {
                event_count.push(0)
              }
            }
          })
          this.option.xAxis[0].data = this.map_round
          if (this.params.data_type == 2) {
            this.option.series[0].data = total_amount
          } else {
            this.option.series[0].data = event_count
          }
          this.mychart = chart
          this.echartChangeTheme2()
          chart.clear()
          chart.setOption(this.option)

          chart.off('click')
          chart.on('click', (params) => {
            if (this.curInt === params.dataIndex) {
              this.curInt = ''
              this.list_params.round_ids = []
            } else {
              let index = this.round_ids_arr.findIndex((a) => a.name === params.name)
              this.list_params.round_ids = this.round_ids_arr[index].ids
              this.curInt = params.dataIndex
            }
            this.list_params.page = 1
            this.getList()
            chart.setOption(this.option)
          });
        }
        else if (this.params.tag_arr.length > 1){
          // arr_option
          let chart = echarts.init(document.getElementById('arr_chart0'))
          let legend_arr = [],
              series_arr = []
          this.params.tag_arr.map((a,index) => {
            legend_arr.push(filter.dealName(a, this.tagmap) + '|' + this.params.unit_type)
            series_arr.push({
              name: filter.dealName(a, this.tagmap) + '|' + this.params.unit_type,
              type: 'line',
              data: [],
              label: { normal: { show: false, color: '' }},
              itemStyle: { normal: { color: '' }},
              lineStyle: { normal: { color: '' }}
            })
          })

          this.arr_option.legend.data = legend_arr
          this.arr_option.series = series_arr

          this.arr_option.xAxis[0].data = this.map_round
          this.arr_option.xAxis[1].show = false
          this.arr_option.grid.bottom = '10px'
          // total_amount
          this.params.tag_arr.map((a,i) => {
            let y_even = [], y_amount = []
            this.map_round.map(b => {
              let arr = chart_data.filter(c => b == c.round_name && a == c.tag_id)
              if(arr.length > 0) {
                let sum = 0
                arr.map(e => {
                  if (this.params.data_type == 2) {
                    sum = sum + filter.amountFilter(e.total)
                  } else {
                    sum = sum + Number(e.total)
                  }
                })
                y_amount.push(Math.round(sum*100)/100)
                y_even.push(sum)
              } else {
                y_amount.push(0)
                y_even.push(0)
              }
            })
            this.arr_option.series[i].data = this.params.data_type == 2 ? y_amount : y_even
            this.arr_option.series[i].label.normal.color = this.legend_colors[i]
            this.arr_option.series[i].itemStyle.normal.color = this.legend_colors[i]
            this.arr_option.series[i].lineStyle.normal.color = this.legend_colors[i]
          })

          this.arr_option = JSON.parse(JSON.stringify(this.arr_option))
          this.echartChangeTheme6()
          chart.clear()
          chart.off('click')
          this.arr_option.legend.formatter = (params => {
            return params.split('|')[0]
          })
          this.arr_option.tooltip.formatter = (params => {
            let name = params[0].name,
              seriesName = params[0].seriesName,
              dw = this.params.data_type == 2 ? '亿' + filter.deal(seriesName.split('|')[1], 'unit') : '起',
              title = '',
              html = ''

              title = `<p class="p1">` + name + `</p>`

            params.map(a => {
              html = html + `<p class="p2"><i class="cir_i" style="background-color: ` + a.color + `"></i>` + a.seriesName.split('|')[0] + `：<span>` + a.value + dw +`</span></p>`
            })
            return `<div class="chart_tip">` + title + html + `</div>`
          })
          chart.setOption(this.arr_option)
          this.mychart = chart
        }
        this.can_render = true
        this.spinShow = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getList() {
      let res = await hotTagOfEventList(this.list_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // 列表数据
        this.$set(this.$data, 'list', res.res)
        if (this.list_params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    changely(tag_id, tag_name) {
      _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '细分领域点击（' + tag_name + '）'])
      if (this.user_key) {
        if (tag_id == '') {
          this.years = [2011, this.moment_year]
          this.params.s_time = 2011
          this.params.e_time = this.moment_year
          this.list_params.s_time = 2011
          this.list_params.e_time = this.moment_year
          this.params.tag_arr = []
          this.list_params.tag_arr = []
        } else {
          let len = this.params.tag_arr.length
          let index = this.params.tag_arr.findIndex(a => a == tag_id)

          if (index == -1) {
            if (len == 2 && !this.is_vip) {
              this.page_modal = true
              return false
            }
            if (len == 5 && this.is_vip) {
              this.$Message.warning('只能选择5种领域');
              
              return false
            }
            this.params.tag_arr.push(tag_id)
            this.list_params.tag_arr.push(tag_id)
          } else {
            this.params.tag_arr.splice(index, 1)
            this.list_params.tag_arr.splice(index, 1)
          }
        }
        this.list_params.page = 1
        this.getMap()
        this.getList()
      } else {
        this.login()
      }
    },
    haddleSave() {
      _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name + '下载点击'])
      this.loginVipFlow(() => {
        html2canvas(document.getElementById('up_img'), {
          scale: 1,
          backgroundColor: !this.theme_switch ? '#2A2F42' : '#ffffff',
          useCORS: true,
          tainttest: true
        }).then((canvas) => { // canvas是个dom对象
          let save_url = canvas.toDataURL("image/png")
          this.imgbase = save_url
          this.visible = true
        })
      })
    },
    spliceString(s) { // 截取字符串
      return s.substr(0, 6) + '...'
    },
    changeKeyType(key) { // 选择渲染的key值
      this.loginVipFlow(() => {
        this.params.data_type = key
        this.curInt = ''
        this.list_params.round_ids = []
        this.getMap()
        this.getList()
      })
    }
  },

  created() {
    this.getMeta()
    this.getMap()
    this.getList()
  },
  mounted() {
    this.getDivColors('#FFCB6A', '#E96350', 3)
  },
  destroyed() {
    this.option = ''
    this.mychart = ''
  },
  watch: {
    theme_switch(val) {
      if (!this.spinShowv && this.mychart) {
        if (this.params.tag_arr.length == 1) {
          this.echartChangeTheme2()
          this.mychart.setOption(this.option, true)
        }
        else if (this.params.tag_arr.length > 1) {
          this.echartChangeTheme6()
          this.mychart.setOption(this.arr_option, true)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
.hot_container
  position: relative;
  .condition
    position: absolute;
    top: 0;
    right: 30px;
    z-index: 7;
</style>
